import gsap from 'gsap'
import { CustomEase } from "gsap/CustomEase";
import * as $ from 'jquery';
import { loadAnimation, start } from 'bodymovin';
import dataanim from "../anim/x.json";
import lottie from "lottie-web";
import { ScrollTrigger } from "gsap/ScrollTrigger";
export var pageload10th = ()=>{
    pageloading()
}
export var starsmove = ()=>{
    stars()
}
export var bigxcall = ()=>{
    bigX()
}
export var titleload = ()=>{
    titleloading()
}
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);



var tl = gsap.timeline()
function bigX(){

    var animData = {
        container: document.getElementById('bigx'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: dataanim
    };
    var anim = lottie.loadAnimation(animData);

}

function pageloading()
{
    var window1 = document.getElementById("window1");
    var window2 = document.getElementById("window2");
    var a = document.querySelector("#a span")
    var b = document.querySelector("#b")
    var c = document.querySelector("#c span")
    tl.to(b,{duration: 0.7, height:"100px", ease: "power3.out"})
    tl.to(a,{duration: 0.7, marginRight:"5px", ease: "power3.out"})
    tl.to(c,{duration: 0.7, marginLeft:"5px", ease: "power3.out"},"-=1")
    // tl.from(b,{duration: 0.7, height:"0", ease: "power3.out"})
    // tl.from(a,{duration: 0.7, marginRight:"-100%", ease: "power3.out"})
    // tl.from(c,{duration: 0.7, marginLeft:"-100%", ease: "power3.out"},"-=1")
    tl.to(a,{
        textContent: "0",  
        snap: { textContent: 1 },
        duration: 1,
        ease: "sine.in"
    })
    tl.to(b,{duration: 1, height:"100vh", ease: "power3.out", delay: 0.3, ease: CustomEase.create("custom", "M0,0 C0,0 0.075,-0.029 0.144,-0.038 0.24,-0.05 0.472,-0.042 0.574,0.122 0.82,0.517 1,1 1,1 ")})
    tl.to(a,{duration: 0.3, opacity: 0})
    tl.to(b,{duration: 0.3, opacity: 0},"-=0.3").to(c,{duration: 0.3, opacity: 0},"-=0.3")
    tl.to(".window",{duration: 3, width: 0,ease: CustomEase.create("custom", "M0,0 C0.3,-0.04 0.192,0.726 0.318,0.852 0.45,0.984 0.504,1 1,1 ")});
    tl.to("#pagetransition", {display:"none"},"-=2")
}



function titleloading()
{
    console.log("loading title")
    this.titlespan = document.querySelectorAll(".title span")
    this.titletl = gsap.timeline()
    this.titletl.to(this.titlespan,{duration:1,opacity:1,y:"0%",stagger:0.1,ease: "power3.out"})
    tl.from(document.querySelectorAll(".textleft div span"),{duration:1,opacity:0,y:"+=100",stagger:0.1},"-=2")

}
var startl = gsap.timeline();

function stars(){
    if(startl){

    }
    else{
        startl = gsap.timeline()
    }
    $(".section").off()
    startl.pause(0)
    startl.play()
    startl.to(".star", 1, {
        scale: randomNumber(1,1.5),left:()=>{return `+=${randomNumber(-50,50)}%`},
        top:()=>{return `+=${randomNumber(-50,50)}%`},yoyo:true,ease:"power4.out",repeat: -1,delay: ()=>{return randomNumber(0,1)},
        repeatRefresh: true
    });   

    $(".section").mousemove(function(e) {
        parallaxIt(e, ".star", -50, "#stars");
    });
}
window.addEventListener("resize",()=>{
    if($(window).width()>768){
        startl.play()
    }
})

function parallaxIt(e, target, movement, hovercontainer) {
var $this = $(hovercontainer);
var relX = e.pageX - $this.offset().left;
var relY = e.pageY - $this.offset().top;
var movementtl = gsap.timeline();

movementtl.to(target, 3, {
    yoyo: true,
    x: (relX - $this.width() / 2) / $this.width() * movement,
    y: (relY - $this.height() / 2) / $this.height() * movement
});
}



function randomNumber(min, max) {
    return Math.random() * (max - min) + min;
}






// // stars()
// titleloading()
// bigX()